'use client';

import {useState} from "react";
import { EventCard } from "./EventCard/EventCard";
import {EventListQuery} from "@vereinsheim/backend-types/src/event";
import Button from "@/app/pwa/components/Button";
import {ErrorText} from "@/app/pwa/components/form/ErrorText";
import NoContent from "@/app/pwa/components/NoContent";
import ChevronDown from "@/assets/icon/chevron-down.svg";

import {EventWrapper} from "@/app/pwa/(main-layout)/events/lib/types";
import { apiEventListPath } from "@/utils/urlHelper";

export default function EventItemList({initialEventList, queryParams, showTeamNames=false, isPast}: {initialEventList: EventWrapper[], queryParams: EventListQuery, showTeamNames?:boolean, isPast?:boolean}) {
  const [events, setEvents] = useState<EventWrapper[]>(initialEventList);
  const [showLoadMore, setShowLoadMore] = useState<boolean>( events.length == queryParams.limit);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function loadMoreEvents(){
    setLoading(true)
    if(!isPast) {
      queryParams.from = events[events.length - 1].start
    } else {
      queryParams.to = events[events.length - 1].start
    }
    const res = await fetch(apiEventListPath(queryParams), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
    if(res.ok){
      const newEvents = await res.json() as EventWrapper[];

      // We got to check if the new list includes duplicates and remove them
      // Duplicates happen for events that start at the time that is used in the queryParams (.from or .to)
      const duplicates: EventWrapper[] = []
      const checkedEvents: EventWrapper[] = []
      for (const event of [...events, ...newEvents]) {
          const sameEventAlreadyChecked = checkedEvents.find(checkedEvent => {
            return checkedEvent.type == "game" && event.type == "game" ?
              event.matchId == checkedEvent.matchId :
              (checkedEvent.type == "event" && event.type == "event" ? event.event._id == checkedEvent.event._id : false)
          })
            if(sameEventAlreadyChecked){
              duplicates.push(event)
            } else {
              checkedEvents.push(event)
            }

      }
      const mergedEvents = [...events, ...newEvents.filter(event => !duplicates.includes(event))]
      if(mergedEvents.length == events.length){
        setShowLoadMore(false)
      }
      setEvents(mergedEvents.sort((a,b) => {
        const gameAStart = a.start
        const gameBStart = b.start
        return queryParams.from ? gameAStart-gameBStart : gameBStart-gameAStart;
      }))
      setLoading(false);
    } else {
      setError("Beim Laden weiterer Termine ist ein Fehler aufgetreten. Bitte versuche es später erneut.")
      setLoading(false);
    }
  }
  if(!events || events.length === 0){
    return <NoContent>
      Es gibt keine {queryParams.to ? "vergangenen" : "aktuellen"} Termine
    </NoContent>
  }
  let weekSeperatorDone = false
  const timeToShowWeekSeperator = Date.now() + 7 * 24 * 60 * 60 * 1000

  return <>
    <div className="flex flex-col gap-space-y">
      {events.map((event, index) => {
        const isFuture = event.start > timeToShowWeekSeperator;
        const isPreviousEventMatched = index > 0 ? events[index-1].start > timeToShowWeekSeperator : isFuture

          if (!weekSeperatorDone && index < events.length-1 && isFuture && !isPreviousEventMatched){
            weekSeperatorDone = true
            return (<div key={`event-${event.event._id}`} className={"flex-col"}>
              <div className="relative flex py-5 items-center">
                <div className="flex-grow border-t border-muted opacity-35"></div>
                <span className="flex-shrink mx-4 text-muted flex items-center justify-center gap-2"><ChevronDown className="h-4 w-4" /> In mehr als einer Woche <ChevronDown className="h-4 w-4" /></span>
                <div className="flex-grow border-t border-muted opacity-35"></div>
              </div>

              <EventCard key={`event-${event.event._id}`} eventWrapper={event} showTeamNames={showTeamNames} />
            </div>)
          }
          return <EventCard key={`event-${event.event._id}`} eventWrapper={event} showTeamNames={showTeamNames} />;
        }
      )}
    </div>

    {showLoadMore &&
      <div className="mt-6 flex justify-center">
        <Button loading={loading} onClick={loadMoreEvents} className="w-full justify-center lg:w-auto">
          <ChevronDown className="mr-blank" />
          Weitere Termine laden
        </Button>
      </div>
    }
    {error && <ErrorText className={`mt-1 text-sm`}>{error}</ErrorText>}
  </>;
}
